import { DataGrid, type DataGridProps, type GridValidRowModel } from '@shared/components';

import { QConfigListNoRowsOverlay } from '../qconfig-list-no-rows-overlay';

import { type QConfig, columns } from './columns';

type QContentListTableProps<TRowModel extends GridValidRowModel> = Omit<
  DataGridProps<TRowModel>,
  'columns'
>;

export default function QConfigListTable(props: Readonly<QContentListTableProps<QConfig>>) {
  return (
    <DataGrid
      slots={{ noRowsOverlay: QConfigListNoRowsOverlay }}
      disableColumnMenu
      {...props}
      columns={columns}
      sx={(theme) => ({
        '--DataGrid-overlayHeight': '412px',
        '.MuiDataGrid-overlayWrapperInner': {
          display: 'flex',
        },
        minHeight: '412px',
        backgroundColor: theme.palette.common.white,
        borderRadius: theme.shape.rounded(2),
        border: `1px solid ${theme.palette.grey[200]}`,
        boxShadow: 'none',
        '.MuiDataGrid-cell': {
          padding: theme.spacing(3),
          paddingBottom: theme.spacing(2.75),
        },
        '.MuiDataGrid-columnHeader': {
          padding: theme.spacing(3),
        },
        '.MuiDataGrid-cell:last-child': {
          padding: theme.spacing(1.5),
        },
      })}
      getRowHeight={() => 52}
    />
  );
}
